<template>
  <div class="home-button" @click="goHome">
    <van-icon name="wap-home" size="15" />
    <div class="home-button-text">首页</div>
  </div>
</template>

<script>
import { Icon } from 'vant'

export default {
  name: 'HomeButton',
  components: {
    [Icon.name]: Icon
  },
  methods: {
    goHome() {
      // 检查当前是否已经在首页
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.home-button {
  position: fixed;
  right: 15px;
  bottom: 290px;
  width: 40px;
  height: 40px;
  background-color: #1989fa;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  box-shadow: 0 2px 12px rgba(25, 137, 250, 0.6);
  z-index: 999;
  transition: all 0.3s;
  -webkit-tap-highlight-color: transparent;
}

.home-button-text {
  font-size: 10px;
  margin-top: 2px;
}

.home-button:active {
  transform: scale(0.92);
  background-color: #0e7fe8;
}

@media (max-width: 320px) {
  .home-button {
    right: 10px;
    bottom: 80px;
    width: 50px;
    height: 50px;
  }
}
</style> 